import React, { Component } from 'react'
import './index.css'
import { BsyUtils } from "../../utils/Utils";

class AlertListSelectAppPopupPane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noHome: props.noHome,
      appid: props.appid,
      formid: props.formid,
      name: props.name,
      icon: props.icon,
      appinfo: props.appinfo ? props.appinfo.appinfo : {},
      info:props.info ? props.info : {},
      apps: [],
      forms: [],
      group_open: {},
      isParentcheck:true
    }
    // if (this.props.getValue) {
    //   if (this.state.formid) {
    //     if(this.props.webapi){
    //       // console.log(this.state)
    //       this.props.getValue({
    //         appinfo:{
    //           appId: this.state.appid,
    //           name: this.state.info.appinfo.name,
    //           style: this.state.info.appinfo.style
    //         },
    //         forminfo:{
    //           formId: this.state.formid,
    //           formType: this.state.type,
    //           hasCoop: this.state.hasCoop,
    //           icon: this.state.icon,
    //           name: this.state.name
    //         },
    //       })
    //     }else{
    //       this.props.getValue({
    //         appid: this.state.appid,
    //         formid: this.state.formid,
    //         name: this.state.name,
    //         icon: this.state.icon,
    //         hasCoop: this.state.hasCoop,
    //         type: this.state.type,
    //         appinfo: this.state.appinfo,
    //       })
    //     }
    //   }
    // }
  }

  cancelClick = () => {
    this.props.onRemoveRoot();
    // document.getElementsByClassName("BsyAlertListDetail")[0].remove()
  }

  componentDidMount() {
    this.getAppList();
  }

  getAppListData = (data) => {
    let apps = [];
    data.items.map((value, obj) => {
      apps = [...apps, ...value.apps];
      return value;
    })
    return apps;
  }

  getAppList = () => {
    React.axios('/dashboard/app_group/list',{}).then(res => {

      if (res.data.code === 0) {
        const apps = this.getAppListData(res.data);
        this.setState({
          apps: apps,
        }, () => {
          this.onSelectApp(this.state.appid);
        })
      } else {
        BsyUtils.showAjaxTip(res.data, () => {
          // const newState = {
          //     ...this.state,
          //     ...res.data
          // }
          const apps = this.getAppListData(res.data);
          this.setState({
            apps: apps,
          }, () => {
            this.onSelectApp(this.state.appid);
          })
        })
      }
    }).catch(res => {

    })
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const newState = {
      ...this.state,
      ...nextProps,
    }
    this.setState(newState)
  }

  getFormListData = (data) => {
    const { noHome } = this.state;
    this.entryMap = noHome ? {
      ...data.entryMap
    } : {
      ...data.entryMap,
      home: {
        entryId: "home",
        hasCoop: true,
        hasFlow: false,
        icon: '0 icon-app-home ',
        isEvent: false,
        ishide: 0,
        name: React.language('outsider.miniapp.seting.launcher.home'),
        parent: "1",
        seq: 0,
        text: React.language('outsider.miniapp.seting.launcher.home'),
        type: "home",
        _id: "home",
      }
    }
    const entryList = noHome ? [...data.entryList] : [
      { id: 'home' },
      ...data.entryList,
    ]
    let group_open = {};
    entryList.map(function (item, ff) {
      if (item.child) {
        group_open[item.id] = true;
      }
      return item;
    })
    this.setState({
      group_open
    })
    return entryList;
  }

  onSelectApp = (_id, app) => {
    if (!_id) {
      return;
    }
    let data = {}
    if(this.props.webapi){
      data = {
        webapi:true
      }
    }
    React.axios('/dashboard/app/' + _id,data).then(res => {

      const forms = this.getFormListData(res.data);
      let formid = this.state.formid;
      let appinfo = {};
      window.FX.STATIC.user.dock_userid = res.data.dock_userid;
      if(this.state.appinfo){
        if(this.state.appinfo.hasOwnProperty("appId")){
          appinfo = this.state.appinfo
        }else{
          appinfo = app
        }
      }else{
        appinfo = app
      }
      if(!app){
        this.state.apps.map((res)=>{
          if(res._id === _id){
            appinfo = res;
          }
        })
      }
      if (!formid)
        formid = 'home'
      this.setState({
        appid: _id,
        forms: forms,
        formid: formid,
        appinfo: appinfo,
      }, () => {
        if (formid === 'home') {
          // if (this.props.getValue) {
          //   if(this.props.webapi){
          //     this.props.getValue({
          //       appinfo:{
          //         appId: this.state.appid,
          //         name: this.state.appinfo.appname,
          //         style: this.state.appinfo.style
          //       },
          //       forminfo:{
          //         formId: this.state.formid,
          //         formType: this.entryMap[forms[0].id].type,
          //         hasCoop: this.entryMap[forms[0].id].hasCoop,
          //         icon: this.entryMap[forms[0].id].icon,
          //         name: this.entryMap[forms[0].id].name
          //       },
          //     })
          //   }else{
          //     this.props.getValue({
          //       appid: this.state.appid,
          //       formid: this.state.formid,
          //       name: this.entryMap[forms[0].id].name,
          //       icon: this.entryMap[forms[0].id].icon,
          //       hasCoop: this.entryMap[forms[0].id].hasCoop,
          //       type: this.entryMap[forms[0].id].type,
          //       appinfo: this.state.appinfo,
          //     })
          //   }
          // }
        }
      })

    }).catch(res => {

    })
  }

  onSelectForm = (id) => {
    const data = this.entryMap[id];
    if (data.type === 'group')
      return;
    this.setState({
      formid: data.entryId,
      name: data.name,
      icon: data.icon,
      hasCoop: data.hasCoop,
      type: data.type,
      isParentcheck:true
    }, () => {
      if (this.props.getValue) {
        if(this.props.webapi){
          this.props.getValue({
            appinfo:{
              appId: this.state.appid,
              name: this.state.appinfo.appname,
              style: this.state.appinfo.style
            },
            forminfo:{
              formId: this.state.formid,
              formType: this.state.type,
              hasCoop: this.state.hasCoop,
              icon: this.state.icon,
              name: this.state.name
            },
          })
        }else{
          this.props.getValue({
            appid: this.state.appid,
            formid: this.state.formid,
            name: this.state.name,
            icon: this.state.icon,
            hasCoop: this.state.hasCoop,
            type: this.state.type,
            appinfo: this.state.appinfo,
          })
        }
      }
    })


  }

  group_hide = (id) => {
    // const { group_open } = this.state;
    const group_open = {
      ...this.state.group_open,
      [id]: !this.state.group_open[id]
    }
    this.setState({
      group_open: group_open,
    })
  }

  createItem = (value,parentCheck) =>{
    let that = this;
    const { apps, forms, appid, formid, group_open } = this.state;
   
    const { onlyForm,showTypeList } = this.props;
    let ndt = that.entryMap.hasOwnProperty(value.id);
    let flg = false
    if(that.entryMap[value.id]){
      flg = ['form','group','home'].concat(showTypeList || []).indexOf(that.entryMap[value.id].type)>=0  
      if(that.props.webapi){
        flg = ['form','group','etl_table','aggregate_table'].concat(showTypeList || []).indexOf(that.entryMap[value.id].type)>=0
      }
      
    }

    if(!flg){
      return <></>
    }
    return <div className={"item " + ((formid === value.id && this.state.isParentcheck) ? 'select' : '' + (value.child ? 'group' : ''))} onClick={e => { that.onSelectForm(value.id) }} >
      {
        (!value.child && that.entryMap[value.id].type!=="group")? <>
          <i className={
            "node-icon icon-bsy-" + ((that.entryMap[value.id].type === 'dash' || that.entryMap[value.id].type === 'scenes') ? 'dash' : that.entryMap[value.id].type === "etl_table" ? "etl_table" : (!that.entryMap[value.id].hasCoop ? 'form-flow' : 'form')) +" "+ (that.entryMap[value.id].icon<=24? ("icon-bsy-form-"+that.entryMap[value.id].icon):("icon-new-bsy-form-"+that.entryMap[value.id].icon))
          } />
          <span>{that.entryMap[value.id].name}</span>
        </> : <>
          <div className='item-group' onClick={e => { that.group_hide(value.id) }} >
            <i className={
              group_open[value.id] === false ? 'icon-bsy-folder-close' : 'icon-bsy-folder-open'
            } />
            <span>{that.entryMap[value.id].name}</span>
          </div>
          <div className='item-group-form-list' style={{
            display: group_open[value.id] === false ? 'none' : "block",
          }} >
            {
            value.child&&value.child.map(function (valuechild, objchild) {
                if (!that.entryMap[valuechild.id]) {
                  return <></>
                }
                if(onlyForm && (that.entryMap[valuechild.id].type === 'dash' || that.entryMap[valuechild.id].type === 'scenes')){
                  return <></>
                }
                return that.createItem(valuechild)
              })
            }
          </div>
        </>
      }
    </div>
  }

  render() {
    let that = this;
    const { apps, forms, appid, formid, group_open } = this.state;
    const { onlyForm } = this.props
    return (
      <div className={"Bsy-app-form " + window.mode}>
        <div className='left content-wrapper' >
          <div className='app-title' >{React.language('app')}</div>
          <div className='app-list' >
            {
              apps.map(function (value, obj) {
                return <div className={"item " + (appid === value._id ? 'select' : '')} title={value.appname} onClick={e => {that.setState({isParentcheck:false}); that.onSelectApp(value._id, value) }} >
                  <div className={"app-icon color-cover-" + value.style.color}><div className={"imgbg-bby-app imgbg-bby-app-" + value.style.icon} /></div>
                  <span>{value.appname}</span>
                </div>
              })
            }
          </div>
        </div>

        <div className='right content-wrapper'>
          <div className='form-title' >{React.language('form')}</div>
          <div className='form-list' >
            {
              forms.length > 0 ? forms.map( (value, obj) => {
                return that.createItem(value)
              }) : <div className="formEmptyCont">
                <div className="formEmptyText">
                  {React.language('content.empty')}
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }
}
export default AlertListSelectAppPopupPane